<template>
  <VForms
    v-if="profile"
    :initial-values="profile"
    :validation-schema="validations"
    @submit="handleSubmit"
  >
    <template slot-scope="props">
      <form @submit.prevent="props.handleSubmit">
        <v-container
          grid-list-md
          align-center
          fill-height
        >
          <v-layout column>
            <ProfileFormFields :form="props" />
            <v-layout
              row
              justify-end
              align-center
            >
              <v-flex
                text-md-right
                xs12
              >
                <v-btn
                  color="primary"
                  outline
                  @click="props.handleReset"
                >
                  {{ $t('button.clear') }}
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="props.isSubmitting"
                  type="submit"
                >
                  {{ $t('button.save') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>
      </form>
    </template>
  </VForms>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Form as VForms } from '@v-forms/core'
import {
  required,
  helpers,
} from 'vuelidate/lib/validators'
import { PROFILE_KEY, NICKNAME_KEY, ACTION_SAVE_PROFILE } from '../../store/types/profile.types'
import ProfileFormFields from './ProfileFormFields'

const phone = helpers.regex('phone', /^(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/)

export default {
  name: 'ProfileForm',
  components: {
    VForms,
    ProfileFormFields,
  },
  data() {
    return {
      validations: {
        name: { required },
        surname: { required },
        street: { required },
        city: { required },
        zipCode: { required },
        country: { required },
        phone: { required, phone },
      },
    }
  },
  computed: {
    ...mapState({
      profile: state => state.profile[PROFILE_KEY],
      nickname: state => state.profile[NICKNAME_KEY],
    }),
  },
  methods: {
    handleSubmit(values, actions) {
      const profile = Object.assign(values, { nickname: this.nickname })
      const payload = { profile, showAlert: true }
      this.saveProfile(payload)
      actions.setSubmitting(false)
    },
    ...mapActions({
      saveProfile: ACTION_SAVE_PROFILE,
    }),
  },
}
</script>

<style lang="stylus" scoped>

</style>
